module.exports = __webpack_public_path__ + "img/public/SiteIcons/refund.svg?2dd35220";